import React, { useEffect, useState } from "react";
import MyInformation from "../myInformation/MyInformation";
import MyPreferences from "../myPreferences/MyPreferences";
import styled from "styled-components";
import {
  SATabBar,
  SAIcon,
  SAIcons,
  SAInput,
  SAText,
  SAColumns,
} from "@saux/design-system-react";
import { USER_PREFERENCES_TABS } from "../../utils/constants";
import { Modal } from "../../styles/Modal.style";
import { getAdjusterSchedule, getOutofOfficeStatus } from "../../store/actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import MyOutofOffice from "../myOutofOffice/MyOutofOffice";

const TabBar = styled(SATabBar)`
  li {
    width: 50% !important;
    text-align: center;
    padding-top: 30px;
    margin: 0;
  }
   li button{
    cursor: pointer !important;
   }

  li.active {
    border-bottom: 4px solid rgb(77, 132, 11);
    button {
      font-weight: 700;
      border-bottom: none;
      font-size: 19.2px;
      line-height: 23px;
    }
  }
`;
const Profile = styled.div`
  margin: 25px;
  width: 65%;
  height: fit-content;
  background-color: white;
  margin: auto;
  margin-top: 30px;
  border-radius: 8px;
  padding: 35px 15px 0;
  #close-modal {
    cursor: pointer;
    float: right;
    margin-right: 10px;
  }
  #close-modal:hover {
    background-color: rgba(32, 33, 36, 0.039);
  }
  h3 {
    margin-left: 35px;
  }
  .profile-details {
    padding: 30px;
    // div[data-testid="ColumnWrapper"] {
    //     .textLikeInput{
    //         width: 75%;
    //     }
    // }

    .textLikeInput {
      width: 300px;
      margin-bottom: 24px;
    }
    .week-days {
      margin-bottom: 20px;
    }

    #startTime,
    #endTime {
      .textLikeInput {
        width: 175px;
      }
    }

    #save-profile-info {
      float: right;
    }
  }
`;
export default function UserProfile(props: any) {
  const [activeIndex, setActiveIndex] = useState(0);
  const itemLabels = Object.values(USER_PREFERENCES_TABS);
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);
  const outOfOffice = useSelector((state:any)=>state.user.outOfOfficeStatus);
  function onChange(newActiveIndex: number) {
    setActiveIndex(newActiveIndex);
  }
  const modalOnClickHandler = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  // useEffect(()=>{
  //   dispatch(getOutofOfficeStatus({adjusterId:user?.email},  (res: any) => {
  //     console.log(res);
  //   }));
  // },[])

  const closeModal=()=>{
    dispatch(
      getAdjusterSchedule(
        { adjusterId: user.email },
        (res: any) => {
          props.setNotificationSound(
            res.data.getAdjusterSchedule[0].adjusterSetting
              .notificationSoundValue
          );
        }
      )); 
    setActiveIndex(0);
    props.setDisplayModal(false);
  }

  const getComponent = () => {
    switch (activeIndex) {
      case 0:
        return (
          <MyInformation
            displayModal={props.displayModal}
            setDisplayModal={props.setDisplayModal}
            setDefaultIndex = {setActiveIndex}
          />
        );
      case 1:
        return (
          <MyPreferences
            displayModal={props.displayModal}
            setDisplayModal={props.setDisplayModal}
            notificationSound={props.notificationSound}
            setNotificationSound={props.setNotificationSound}
            setIsBrowserNotificationDisabled={props.setIsBrowserNotificationDisabled}
            closeModal ={props.setDisplayModal}
            setDefaultIndex = {setActiveIndex}
          />
        );
      case 2:
        return (
          <MyOutofOffice
            displayModal={props.displayModal}
            setDisplayModal={props.setDisplayModal}
            outOfOffice ={outOfOffice}
            setDefaultIndex = {setActiveIndex}
          />
        );
      
    }
  };
  return (
    props.displayModal && (
      <Modal
        onClickHandler={(event: React.MouseEvent) => modalOnClickHandler(event)}
      >
        <Profile data-testid="my-info">
          <SAColumns>
            <SAText type="heading-3" text="User Profile" weight="bold" />
            <div
              id="close-modal"
              data-testid="close-modal"
              onClick={closeModal}
            >
              <SAIcon icon={SAIcons.x} size="25px" colorVariant="#666666" />
            </div>
          </SAColumns>

          <TabBar
            activeIndex={activeIndex}
            itemLabels={itemLabels}
            onChange={onChange}
          />
          {getComponent()}
        </Profile>
      </Modal>
    )
  );
}


